export const criterionLabels = {
  CUSTOM_AUDIENCE: 'Custom Segment'
}
